import {
  getFirestore,
  doc,
  query,
  collection,
  where,
  getDocs,
  runTransaction,
} from "firebase/firestore";
import { app } from "../firebase/app";
import { Id, Reserved } from "../types";

const db = getFirestore(app);
const storeKind = "reserved";

const SEPARATOR = "|";

function formatDocId(wishlistId: Id, wishId: Id): Id {
  return `${wishlistId}${SEPARATOR}${wishId}`;
}

function parseDocId(docId: Id): { wishlistId: Id; wishId: Id } {
  const [wishlistId, wishId] = docId.split(SEPARATOR);

  return { wishlistId, wishId };
}

export async function storeReserved(
  userId: Id,
  wishlistId: Id,
  wishId: Id,
): Promise<Reserved[]> {
  const sfDocRef = doc(db, storeKind, formatDocId(wishlistId, wishId));
  await runTransaction(db, async (transaction) => {
    const sfDoc = await transaction.get(sfDocRef);
    if (sfDoc.exists()) {
      return;
    }
    transaction.set(sfDocRef, { wishlistId, userId });
  });
  return await fetchReserved(userId);
}

export async function storeUnreserved(
  userId: Id,
  wishlistId: Id,
  wishId: Id,
): Promise<Reserved[]> {
  const sfDocRef = doc(db, storeKind, formatDocId(wishlistId, wishId));
  await runTransaction(db, async (transaction) => {
    const sfDoc = await transaction.get(sfDocRef);
    if (!sfDoc.exists()) {
      return;
    }
    if (sfDoc.data().userId !== userId) {
      return;
    }
    transaction.delete(sfDocRef);
  });
  return await fetchReserved(userId);
}

export async function fetchReserved(userId: Id): Promise<Reserved[]> {
  const q = query(collection(db, storeKind), where("userId", "==", userId));

  try {
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => {
      const { wishlistId, wishId } = parseDocId(doc.id);
      return { wishId, wishlistId, userId: doc.data().userId } as Reserved;
    });
  } catch (e) {
    console.error("fetchReserved", e);
    return [];
  }
}

export async function fetchByWishlist(wishlistId: Id): Promise<Reserved[]> {
  const q = query(
    collection(db, storeKind),
    where("wishlistId", "==", wishlistId),
  );

  try {
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => {
      const { wishlistId, wishId } = parseDocId(doc.id);
      return { wishId, wishlistId, userId: doc.data().userId } as Reserved;
    });
  } catch (e) {
    console.error("fetchByWishlist", e);
    return [];
  }
}
